export default __webpack_public_path__ + "static/media/c3.3c2d40ce.jpg";